import cn from 'classnames';
import Link from 'next/link';
import React from 'react';

import { maxTablet } from '@/constants/vars.constants';
import { useRoutesConfig } from '@/hooks/routes-config';
import { useFiltersQuery } from '@/hooks/used-cars/filters-query.hook';
import { useWindowSize } from '@/hooks/window-size.hook';
import { getSearchResultPath } from '@/services/link.service';
import {
  BrowseItemTypes,
  BrowseTypes,
  VehicleType,
} from '@/types/used-cars/used-cars.types';

import { LinkButton } from '../buttons/link-button/link-button';
import { SliderSlick } from '../slider/slider';

import { BrowseHeading } from './browse-heading/browse-heading';
import styles from './browse-section.module.scss';

export const BrowseSection: React.FC<{
  name: BrowseTypes;
  hideHeadingText?: boolean;
  data: BrowseItemTypes[];
  buttonText?: string;
  item: React.FC<{
    item: BrowseItemTypes;
    name: BrowseTypes;
  }>;
}> = ({ name, hideHeadingText, data, buttonText, item }) => {
  const routes = useRoutesConfig();
  const Item = item;
  const { width } = useWindowSize();
  const isTablet = width != null && width <= maxTablet;
  const { activeCarType } = useFiltersQuery();

  return (
    <div className={styles.wrapper}>
      {!hideHeadingText && (
        <div className={styles.header}>
          <BrowseHeading>
            {activeCarType !== VehicleType.Demo ? (
              (name && name.toLowerCase() == 'brand') ||
              (name && name.toLowerCase() == 'location') ? (
                <Link
                  href={getSearchResultPath(activeCarType, routes)}
                  className={styles.clink}
                >
                  {`Browse Used cars by ${name}:`}
                </Link>
              ) : (
                `Browse Used cars by ${name}:`
              )
            ) : (
              `Browse Demo Used cars by ${name}:`
            )}
          </BrowseHeading>
          {buttonText && (
            <LinkButton
              label={buttonText}
              link={getSearchResultPath(activeCarType, routes)}
            />
          )}
        </div>
      )}
      <div
        className={cn(styles.content, {
          [styles.locationWrapperMobile as string]:
            name === BrowseTypes.location && isTablet,
        })}
      >
        {name === BrowseTypes.location && isTablet ? (
          <SliderSlick
            sliderLength={data.length}
            slidesToShow={isTablet ? 1 : 3}
            id="browse-location-slider"
            isInfinite={isTablet}
            variableWidth={isTablet}
          >
            {data.map((item) => (
              <Item key={item.id} item={item} name={name} />
            ))}
          </SliderSlick>
        ) : name === BrowseTypes.brand && data?.length < 1 ? (
          <div className={styles.noCars}>No vehicles available</div>
        ) : name === BrowseTypes.price ? (
          data.map((item, index) => (
            <div key={index} className={styles.priceRange}>
              <Link href={item?.link ?? ''} className={styles.priceRangelink}>
                {item.name}
              </Link>
            </div>
          ))
        ) : (
          data.map((item) => <Item key={item.id} item={item} name={name} />)
        )}
      </div>
    </div>
  );
};
